import {adaptV4Theme, createTheme} from "@mui/material/styles";
import {blue, indigo, lightBlue} from "@mui/material/colors";

export const ATLANTIS_APP_MAX_WIDTH = 1795;

export const createAtlantisTheme = ({type = "light", fontSize = 16, primary, secondary} = {}) => {
	const mode = type;
	const isLight = mode === "light";

	return createTheme(adaptV4Theme({
		palette: {
			mode,
			type: mode,
			primary: primary || {
				main: isLight ? indigo["A700"] : lightBlue[300],
				light: blue["A200"],
				dark: blue[900],
			},
			secondary: secondary || {
				main: isLight ? "#00a8a8" : lightBlue[200],
				light: lightBlue["A100"],
				dark: "#007a7a",
			},
			background: {
				default: isLight ? "#eef5fb" : "#101722",
				paper: isLight ? "rgba(255,255,255,0.82)" : "rgba(24,31,43,0.86)",
			},
			text: {
				primary: isLight ? "#203240" : "#eef6ff",
				secondary: isLight ? "#627687" : "#b7c6d4",
			},
		},
		shape: {
			borderRadius: 16,
		},
		typography: {
			fontFamily: [
				"Jost",
				"Roboto",
				"Helvetica Neue",
				"Arial",
				"sans-serif"
			].join(","),
			fontSize,
		},
		components: {
			MuiContainer: {
				styleOverrides: {
					root: {
						maxWidth: `${ATLANTIS_APP_MAX_WIDTH}px !important`,
						marginLeft: "auto",
						marginRight: "auto",
					},
				},
			},
		},
	}));
};
